import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

/**
 * Public API - for endpoints that don't require authentication
 * This API does NOT add auth headers or instanceId query params
 */
export const publicApi = createApi({
  reducerPath: "publicApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/v1",
  }),
  endpoints: () => ({}),
});
